(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgm2-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rgm2-announcement')) {
    customElements.define(
      'rgm2-announcement',
      class Rgm2Announcement extends HTMLElement {
        connectedCallback() {
          if (!this.initialized) {
            this.track = this.querySelector('[data-rgm2-ann-track]');
            this.items = Array.from(this.querySelectorAll('[data-rgm2-ann-item]'));
            if (!this.track || this.items.length < 2) return;
            this.initialized = true;

            this.interval = 4000;
            this.pauses = new Set();
            this.mobileQuery = window.matchMedia('(max-width: 600px)');
            this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
            this.update = this.update.bind(this);
            this.onVisibility = () => this.setPause('hidden', document.hidden);

            // Hover pause for real mice only: touch taps do not fire a reliable leave.
            this.addEventListener('pointerenter', (event) => {
              if (event.pointerType === 'mouse') this.setPause('hover', true);
            });
            this.addEventListener('pointerleave', (event) => {
              if (event.pointerType === 'mouse') this.setPause('hover', false);
            });
            this.addEventListener('focusin', () => this.setPause('focus', true));
            this.addEventListener('focusout', (event) => {
              if (!this.contains(event.relatedTarget)) this.setPause('focus', false);
            });
            // A swipe restarts the countdown so the next message does not jump in right away.
            this.track.addEventListener('touchstart', this.update, { passive: true });
            this.addEventListener('shopify:block:select', (event) => {
              this.setPause('editor', true);
              this.goTo(this.items.indexOf(event.target));
            });
            this.addEventListener('shopify:block:deselect', () => this.setPause('editor', false));
          }

          this.mobileQuery.addEventListener('change', this.update);
          this.motionQuery.addEventListener('change', this.update);
          document.addEventListener('visibilitychange', this.onVisibility);
          if (document.hidden) {
            this.pauses.add('hidden');
          } else {
            this.pauses.delete('hidden');
          }
          // No auto-advance while the bar is scrolled out of view.
          if ('IntersectionObserver' in window) {
            this.viewObserver = new IntersectionObserver((entries) => {
              entries.forEach((entry) => this.setPause('offscreen', !entry.isIntersecting));
            });
            this.viewObserver.observe(this);
          }
          this.update();
        }

        disconnectedCallback() {
          if (!this.initialized) return;
          this.stop();
          this.mobileQuery.removeEventListener('change', this.update);
          this.motionQuery.removeEventListener('change', this.update);
          document.removeEventListener('visibilitychange', this.onVisibility);
          if (this.viewObserver) {
            this.viewObserver.disconnect();
            this.viewObserver = null;
          }
          this.pauses.delete('offscreen');
        }

        setPause(reason, paused) {
          if (paused) {
            this.pauses.add(reason);
          } else {
            this.pauses.delete(reason);
          }
          this.update();
        }

        stop() {
          if (this.timer) window.clearInterval(this.timer);
          this.timer = null;
        }

        update() {
          this.stop();
          if (!this.mobileQuery.matches || this.motionQuery.matches || this.pauses.size) return;
          this.timer = window.setInterval(() => this.next(), this.interval);
        }

        currentIndex() {
          const left = this.track.getBoundingClientRect().left;
          let index = 0;
          let best = Infinity;
          this.items.forEach((item, i) => {
            const distance = Math.abs(item.getBoundingClientRect().left - left);
            if (distance < best) {
              best = distance;
              index = i;
            }
          });
          return index;
        }

        goTo(index, instant) {
          const item = this.items[index];
          if (!item) return;
          const offset = item.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
          const smooth = !instant && !this.motionQuery.matches;
          this.track.scrollTo({ left: this.track.scrollLeft + offset, behavior: smooth ? 'smooth' : 'auto' });
        }

        next() {
          if (this.track.scrollWidth <= this.track.clientWidth + 1) return;
          const target = (this.currentIndex() + 1) % this.items.length;
          // Wrapping from the last message back to the first is a jump, not a visible rewind.
          this.goTo(target, target === 0);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgm2-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rgm2-header')) {
    customElements.define(
      'rgm2-header',
      class Rgm2Header extends HTMLElement {
        connectedCallback() {
          this.drawer = this.querySelector('[data-rgm2-drawer]');
          this.drawerToggle = this.drawer ? this.drawer.querySelector('summary') : null;
          this.drawerPanel = this.querySelector('[data-rgm2-drawer-panel]');
          this.drawerClose = this.querySelector('[data-rgm2-drawer-close]');
          this.search = this.querySelector('[data-rgm2-search]');
          this.searchToggle = this.querySelector('[data-rgm2-search-toggle]');
          this.dropdowns = Array.from(this.querySelectorAll('[data-rgm2-dropdown]'));
          this.hoverQuery = window.matchMedia('(hover: hover)');
          this.desktopQuery = window.matchMedia('(min-width: 990px)');

          this.onDocumentClick = this.onDocumentClick.bind(this);
          this.onKeydown = this.onKeydown.bind(this);
          this.onBreakpoint = this.onBreakpoint.bind(this);

          document.addEventListener('click', this.onDocumentClick);
          this.addEventListener('keydown', this.onKeydown);
          this.desktopQuery.addEventListener('change', this.onBreakpoint);

          if (this.drawer && this.drawerToggle) {
            this.drawer.addEventListener('toggle', () => this.onDrawerToggle());
            if (this.drawerClose) this.drawerClose.addEventListener('click', () => this.closeDrawer(true));
          }

          // Dawn sizes the predictive results to the space below .section-header. On mobile the
          // search row is an overlay under the header, so the results start lower than that:
          // re-measure each time predictive-search.js sets [open].
          this.searchElement = this.search ? this.search.querySelector('predictive-search') : null;
          if (this.searchElement && 'MutationObserver' in window) {
            this.resultsObserver = new MutationObserver(() => this.fitSearchResults());
            this.resultsObserver.observe(this.searchElement, { attributes: true, attributeFilter: ['open'] });
          }

          if (this.search && this.searchToggle) {
            this.searchToggle.setAttribute('role', 'button');
            this.searchToggle.setAttribute('aria-controls', this.search.id);
            this.searchToggle.setAttribute('aria-expanded', 'false');
            this.searchToggle.addEventListener('click', (event) => {
              event.preventDefault();
              this.toggleSearch();
            });
            this.searchToggle.addEventListener('keydown', (event) => {
              if (event.code !== 'Space') return;
              event.preventDefault();
              this.toggleSearch();
            });
          }

          this.dropdowns.forEach((details) => {
            const item = details.parentElement;
            const summary = details.querySelector('summary');
            const panel = item.querySelector('.rgm2-header__panel');
            details.addEventListener('toggle', () => {
              if (details.open) item.classList.remove('is-dismissed');
              summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
            });
            // Focus can only reach the panel links while the panel is visible (details open,
            // or hover on pointer devices). Opening the details here keeps aria-expanded true
            // whenever focus is inside the panel.
            item.addEventListener('focusin', (event) => {
              if (panel && panel.contains(event.target) && !details.open) details.open = true;
            });
            item.addEventListener('mouseleave', () => {
              item.classList.remove('is-dismissed');
              if (panel && panel.contains(document.activeElement)) return;
              if (this.hoverQuery.matches) details.open = false;
            });
            item.addEventListener('focusout', (event) => {
              if (item.contains(event.relatedTarget)) return;
              item.classList.remove('is-dismissed');
              details.open = false;
            });
          });
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onDocumentClick);
          this.desktopQuery.removeEventListener('change', this.onBreakpoint);
          if (this.resultsObserver) this.resultsObserver.disconnect();
          this.setPageInert(false);
        }

        onDocumentClick(event) {
          this.dropdowns.forEach((details) => {
            if (details.open && !details.parentElement.contains(event.target)) details.open = false;
          });
          // The mobile search row covers the top of the page, so a tap outside the header closes it.
          if (
            this.classList.contains('is-search-open') &&
            !this.desktopQuery.matches &&
            event.target instanceof Node &&
            !this.contains(event.target)
          ) {
            this.toggleSearch(false);
          }
        }

        fitSearchResults() {
          if (!this.searchElement.hasAttribute('open') || this.desktopQuery.matches) return;
          const results = this.searchElement.querySelector('[data-predictive-search]');
          if (!results) return;
          const available = Math.floor(window.innerHeight - results.getBoundingClientRect().top - 12);
          results.style.maxHeight = `${Math.max(available, 160)}px`;
        }

        onBreakpoint() {
          if (!this.desktopQuery.matches) return;
          if (this.drawer && this.drawer.open) this.drawer.open = false;
          this.setPageInert(false);
        }

        onDrawerToggle() {
          const open = this.drawer.open;
          this.drawerToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          this.setPageInert(open);
          if (open) {
            this.toggleSearch(false);
            if (this.drawerClose) window.requestAnimationFrame(() => this.drawerClose.focus());
          }
        }

        // While the drawer (a modal dialog) is open, the rest of the page is inert so screen
        // reader virtual cursors cannot leave it. Only elements this header made inert are restored.
        setPageInert(inert) {
          if (inert) {
            if (this.inertTargets) return;
            const selector =
              '#MainContent, .shopify-section-group-footer-group, .shopify-section-group-header-group, .rgm2-announcement-section';
            this.inertTargets = Array.from(document.querySelectorAll(selector)).filter(
              (element) => !element.contains(this) && !element.inert
            );
            this.inertTargets.forEach((element) => {
              element.inert = true;
            });
            return;
          }
          if (!this.inertTargets) return;
          this.inertTargets.forEach((element) => {
            element.inert = false;
          });
          this.inertTargets = null;
        }

        closeDrawer(returnFocus) {
          if (!this.drawer) return;
          this.drawer.open = false;
          if (returnFocus && this.drawerToggle) this.drawerToggle.focus();
        }

        toggleSearch(force) {
          if (!this.search || !this.searchToggle) return;
          const open = typeof force === 'boolean' ? force : !this.classList.contains('is-search-open');
          this.classList.toggle('is-search-open', open);
          this.searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open) {
            const input = this.search.querySelector('input[type="search"]');
            if (input) input.focus();
          }
        }

        focusableInDrawer() {
          return Array.from(
            this.drawerPanel.querySelectorAll('a[href], button:not([disabled]), summary, input:not([type="hidden"])')
          ).filter((element) => {
            if (element.closest('details:not([open]) > :not(summary)')) return false;
            return element.getClientRects().length > 0;
          });
        }

        trapDrawerFocus(event) {
          const focusable = this.focusableInDrawer();
          if (!focusable.length) return;
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (!this.drawerPanel.contains(document.activeElement)) {
            event.preventDefault();
            first.focus();
          } else if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }

        onKeydown(event) {
          const drawerOpen = this.drawer && this.drawer.open && this.drawerPanel;

          if (event.key === 'Tab') {
            if (drawerOpen) this.trapDrawerFocus(event);
            return;
          }

          if (event.key !== 'Escape' && event.key !== 'Esc') return;

          if (drawerOpen) {
            event.preventDefault();
            this.closeDrawer(true);
            return;
          }

          const item = event.target.closest('[data-rgm2-nav-item]');
          if (item) {
            const details = item.querySelector('[data-rgm2-dropdown]');
            if (details) details.open = false;
            item.classList.add('is-dismissed');
            const summary = item.querySelector('summary');
            if (summary) summary.focus();
            return;
          }

          if (this.classList.contains('is-search-open') && this.search.contains(event.target)) {
            this.toggleSearch(false);
            this.searchToggle.focus();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
